import "./style.scss"

import React from "react"
import { Trans, useTranslation } from "react-i18next"

import { ENV } from "../../constants/env"
import Head from "../head/index"
import Layout from "../layout/index"

const Error = () => {
  const { t } = useTranslation("errors")

  return (
    <div className="error-page">
      <Head />
      <Layout>
        <main>
          <h1>{t("generic.heading")}</h1>
          <p>
            <Trans
              i18nKey="errors:generic.body"
              components={[
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a key="support" href={"mailto:" + ENV.HELP_EMAIL} />
              ]}
            />
          </p>
        </main>
      </Layout>
    </div>
  )
}

export default Error
